export default () => ({
  actionOrigin: 'email verification banner',
});
